import { Add, GridView } from "@mui/icons-material";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";

import { useDispatch } from "react-redux";
import { openModal } from "../../Redux/modalSlice";
import CreateBusiness from "./CreateBusiness";

const Business = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <CreateBusiness />
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>
                <ButtonTable
                    startIcon={<Add />}
                    onClick={() => dispatch(openModal())}
                >
                    New
                </ButtonTable>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Business;
